import {
  RELOAD,
  SWITCH_ORGANIZATION,
  SWITCH_ORGANIZATION_FAILED,
  SWITCH_ORGANIZATION_SUCCESS,
} from './constants';

export const switchOrganizationAction = (organizationId: string) => ({
  type: SWITCH_ORGANIZATION,
  organizationId,
});

export const reloadAction = () => ({
  type: RELOAD,
});

export const switchOrganizationSuccessAction = () => ({
  type: SWITCH_ORGANIZATION_SUCCESS,
});

export const switchOrganizationFailedAction = (error) => ({
  type: SWITCH_ORGANIZATION_FAILED,
  error,
});
